import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(private lang: string, private pattern: string) {
  }

  transform(value: any): any {
    const datePipe: DatePipe = new DatePipe(this.lang);
    return datePipe.transform(value, this.pattern);
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/ubi-core/pipes/LocalizedDatePipe.ts